import { render, staticRenderFns } from "./MusicV2.vue?vue&type=template&id=77c1de58"
import script from "./MusicV2.vue?vue&type=script&lang=js"
export * from "./MusicV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports